export const formatToDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const year = date.getFullYear();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
};
export const formatToDateFull = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const year = date.getFullYear();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");

  return `${day} ${month} ${year}`;
};


export const formatToDateTime = (e) => {
  if (!e) return "";
  const date = new Date(e);

  const year = date.getFullYear();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  const dateString = `${day}-${month}-${year}`;
  const timeString = `${hours}:${minutes}:${seconds} ${ampm}`;

  return `${dateString} ${timeString}`;
};

export const formatToDateInTime = (e) => {
  if (!e) return "";
  const date = new Date(e);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  // const seconds = String(date.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");
  const timeString = `${hours}:${minutes} ${ampm}`;

  return `${timeString}`;
};

export const formatToTime = (e) => {
  if (!e) return "";

  const parts = e.split(":");
  let hours = parseInt(parts[0], 10);
  const minutes = parts[1] || "00";
  const seconds = parts[2] || null;

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedHours = String(hours).padStart(2, "0");

  const timeString = seconds
    ? `${formattedHours}:${minutes} ${ampm}`
    : `${formattedHours}:${minutes} ${ampm}`;

  return timeString;
};

export const getDateToWeek = (e, format = "short") => {
  if (!e) return "";
  const date = new Date(e);
  return date.toLocaleDateString("en-US", { weekday: format });
};

export const getPreviousDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  d.setDate(d.getDate() - 1);
  return d;
};

export const formatDate = (date) => {
  return date.toISOString().split("T")[0];
};

export const differenceInDays = (date1, date2) => {
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};